import { Component, EventEmitter, Input, Output, ViewChild, OnInit, inject, OnDestroy } from '@angular/core';
import { ModalComponent } from '@rn-platform/frontend-shared-ui-common';
import { ChangeOrganizationFolderDialogConfiguration } from './change-organization-folder-configuration.model';
import { ChangeOrganizationModalService } from './change-organization-modal.service';
import { Subscription } from 'rxjs';
@Component({
  selector: 'app-change-organization-folder-dialog',
  templateUrl: './change-organization-folder-dialog.component.html',
  styleUrls: ['./change-organization-folder-dialog.component.scss'],
  standalone: false
})
export class ChangeOrganizationFolderDialogComponent implements OnInit, OnDestroy {
  @ViewChild('modalRef') modalComponent: ModalComponent;
  @Output() confirmChange = new EventEmitter<ChangeOrganizationFolderDialogConfiguration>();
  actionTitle: string;
  originalName: string;
  newName: string;
  private readonly changeOrganizationModalService = inject(ChangeOrganizationModalService);
  private readonly subscriptions: Subscription[] = [];

  ngOnInit(): void {
    const sub = this.changeOrganizationModalService.modalState$.subscribe((data) => {      
    if(!data) return;
    if (data?.config)
    {
        this._config = data.config;
        this.actionTitle = this._config.actionTitle;
        this.originalName = this._config.originalName;
        this.newName = this._config.newName;
    }
    if (data?.isOpen) {
      this.open();
    } else {
      this.close();
    }
    });
    this.subscriptions.push(sub);
  }

  ngOnDestroy(): void {
    for (const s of this.subscriptions) {
      s.unsubscribe();
    }
  }

  private _config: ChangeOrganizationFolderDialogConfiguration;

  @Input()
  set config(config: ChangeOrganizationFolderDialogConfiguration) {
    this._config = config;
    if (config) {
      this.actionTitle = config.actionTitle;
      this.originalName = config.originalName;
      this.newName = config.newName;
    }
  }
  get changeOrganizationFolderDialogConfig(): ChangeOrganizationFolderDialogConfiguration {
    return this._config;
  }

  public open(): void {
    this.modalComponent?.open();
  }

  public close(): void {
    this.modalComponent?.close();
  }

  public confirm(): void {
    this.confirmChange.emit(this.changeOrganizationFolderDialogConfig);
    this.modalComponent?.close();
  }
}
